// This file is automatically generated. Do not edit it directly.
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';

import { getSupabaseUrl, getAnonKey } from '@/utils/supabaseUrl';

const SUPABASE_URL = getSupabaseUrl();
const SUPABASE_PUBLISHABLE_KEY = getAnonKey();

export const SUPABASE_URL_EXPORT = SUPABASE_URL;

// Singleton guard: prevent HMR or accidental duplicate imports from creating
// multiple Supabase clients (which causes parallel token refreshes and 429s).
const globalForSupabase = globalThis as unknown as {
  __chipchip_supabase__?: SupabaseClient<Database>;
};

type SupabaseLockFunc = <R>(
  name: string,
  acquireTimeout: number,
  fn: () => Promise<R>
) => Promise<R>;

const authLock: SupabaseLockFunc = async (name, _acquireTimeout, fn) => {
  const lockManager = typeof navigator !== 'undefined'
    ? (navigator as Navigator & {
        locks?: {
          request: <R>(
            name: string,
            options: { mode: 'exclusive' },
            callback: () => Promise<R>
          ) => Promise<R>;
        };
      }).locks
    : undefined;

  if (lockManager?.request) {
    return lockManager.request(name, { mode: 'exclusive' }, async () => fn());
  }

  return fn();
};

export const supabase: SupabaseClient<Database> =
  globalForSupabase.__chipchip_supabase__ ??
  createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      storageKey: 'sb-ladquxscytpamcpyyayc-auth-token',
      persistSession: true,
      // Auto-refresh is OFF by default — a single leader tab (elected via
      // navigator.locks in src/integrations/supabase/authLeader.ts) runs
      // startAutoRefresh(). Follower tabs read the rotated session from
      // localStorage via the storage event. This prevents the per-IP
      // /token 429 refresh-token storms.
      autoRefreshToken: false,
      detectSessionInUrl: true,
      flowType: 'pkce',
      lock: authLock,
    },
  });

if (!globalForSupabase.__chipchip_supabase__) {
  globalForSupabase.__chipchip_supabase__ = supabase;
}
